/**
 * Проксирует URL изображения через локальный бэкенд для обхода CORS
 */
export const proxyImageUrl = (originalUrl: string): string => {
  if (!originalUrl) return originalUrl;

  // Если это уже проксированный URL, возвращаем как есть
  if (originalUrl.includes("/api/proxy/image/")) {
    return originalUrl;
  }

  // Если это URL с back-kt.rct24.ru или api.redcat.ai, проксируем через наш бэкенд
  if (originalUrl.includes("back-kt.rct24.ru") || originalUrl.includes("api.redcat.ai")) {
    const backendUrl =
      process.env.REACT_APP_BACK_URL || "http://localhost:3001/api";
    
    let path;
    if (originalUrl.includes("back-kt.rct24.ru")) {
      path = originalUrl.replace("https://back-kt.rct24.ru/", "");
    } else if (originalUrl.includes("api.redcat.ai")) {
      path = originalUrl.replace("https://api.redcat.ai/", "");
    }
    
    return `${backendUrl}/proxy/image/${path}`;
  }

  // Для всех остальных URL возвращаем как есть
  return originalUrl;
};

/**
 * Проксирует все URL изображений в объекте данных
 */
export const proxyImageUrls = (data: any): any => {
  if (!data) return data;

  if (typeof data === "string") {
    return proxyImageUrl(data);
  }

  if (Array.isArray(data)) {
    return data.map((item) => proxyImageUrls(item));
  }

  if (typeof data === "object") {
    const result = { ...data };

    // Проксируем известные поля с изображениями
    const imageFields = [
      "original",
      "preview",
      "large",
      "thumb",
      "preview_home",
    ];
    const imageObjectFields = ["flat_plan_image", "floor_plan_image", "images"];

    Object.keys(result).forEach((key) => {
      if (imageFields.includes(key) && typeof result[key] === "string") {
        // Прямые поля с URL изображений
        result[key] = proxyImageUrl(result[key]);
      } else if (imageObjectFields.includes(key)) {
        // Объекты или массивы с изображениями
        result[key] = proxyImageUrls(result[key]);
      } else if (key === "links" && typeof result[key] === "object") {
        // Специально для поля links с изображениями
        result[key] = proxyImageUrls(result[key]);
      } else if (typeof result[key] === "object") {
        // Рекурсивно обрабатываем другие объекты
        result[key] = proxyImageUrls(result[key]);
      }
    });

    return result;
  }

  return data;
};
